export default __webpack_public_path__ + "static/fileeasy-f9d073646cd2bd34fde78a467882c722.png";